import { Checkbox, Flex, P } from '@dnb/eufemia';
import { useMemo } from 'react';

import { useUrlFilters } from '@/hooks/useUrlFilters';

export const TAG_FILTER_KEY = 'tags';

export function TagFilter({
  items,
  tagCounts,
}: {
  items: { tags: string[] }[] | undefined;
  tagCounts: Record<string, number>;
}) {
  const { updateFilterInURL, getSelectedKeysFromURL } = useUrlFilters();

  const tagOptions = useMemo(() => {
    if (!items) return [];
    const uniqueTags = [...new Set(items.flatMap((item) => item.tags))];
    return uniqueTags.map((tag) => ({
      selectedKey: tag,
      content: [tag],
    }));
  }, [items]);

  const selectedTags = getSelectedKeysFromURL(TAG_FILTER_KEY, tagOptions);

  const handleChange = (tag: string, checked: boolean) => {
    const newTags = checked ? [...selectedTags, tag] : selectedTags.filter((t) => t !== tag);

    updateFilterInURL(TAG_FILTER_KEY, newTags, tagOptions);
  };

  return (
    <Flex.Vertical top="medium">
      <P modifier="medium" space={{ bottom: 'x-small' }}>
        Tags
      </P>
      {tagOptions.length === 0 ? (
        <P>No tags found</P>
      ) : (
        tagOptions.map(({ selectedKey }) => (
          <Checkbox
            checked={selectedTags.includes(selectedKey)}
            key={selectedKey}
            label={`${selectedKey} (${tagCounts[selectedKey] ?? 0})`}
            onChange={({ checked }) => handleChange(selectedKey, checked)}
            space={{ top: 'xx-small', bottom: 'xx-small' }}
          />
        ))
      )}
    </Flex.Vertical>
  );
}
